import React from 'react';
import useBreakpoint from '../hooks/useBreakpoint';
import { useTheme } from '../ThemeContext';

export default function GuestBanner({ onSignIn, onCreateAccount }) {
  const bp = useBreakpoint();
  const isMobile = bp === 'mobile';
  const { t } = useTheme();

  return (
    <div style={{
      background: 'rgba(0,97,164,0.06)',
      borderLeft: '4px solid #0061a4',
      color: t.text,
      padding: isMobile ? '10px 16px' : '12px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      flexWrap: 'wrap',
      position: 'sticky',
      top: '56px',
      zIndex: 99,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, minWidth: 0 }}>
        <div>
          <span style={{ fontWeight: '700', fontSize: isMobile ? '13px' : '14px', color: '#0061a4' }}>
            Guest mode — your data is only saved on this device.
          </span>
          {!isMobile && (
            <span style={{ fontSize: '13px', color: t.textSecondary, marginLeft: '6px' }}>
              Create an account to keep your data safe, synced, and accessible anywhere.
            </span>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
        <button
          onClick={onSignIn}
          style={{
            background: 'transparent',
            color: t.textSecondary,
            border: `1px solid ${t.borderFaint}`,
            borderRadius: '7px',
            padding: isMobile ? '6px 12px' : '7px 16px',
            fontSize: isMobile ? '12px' : '13px',
            fontWeight: '500',
            cursor: 'pointer',
            fontFamily: 'inherit',
            whiteSpace: 'nowrap',
          }}
        >
          Sign In
        </button>
        <button
          onClick={onCreateAccount}
          style={{
            background: '#0061a4',
            color: 'white',
            border: 'none',
            borderRadius: '7px',
            padding: isMobile ? '6px 12px' : '7px 16px',
            fontSize: isMobile ? '12px' : '13px',
            fontWeight: '700',
            cursor: 'pointer',
            fontFamily: 'inherit',
            whiteSpace: 'nowrap',
          }}
        >
          {isMobile ? 'Get Pro' : 'Get Pro — $6/mo'}
        </button>
      </div>
    </div>
  );
}
